import { LegalPlaceholder, LegalSection } from '@/components/LegalPlaceholder';

/**
 * Términos y condiciones — **contenido provisorio**.
 *
 * 🔴 **No publicar como documento formal.** Los apartados describen cómo
 * funciona la tienda hoy; el texto con valor contractual lo redacta quien
 * corresponda. Un términos y condiciones falso es peor que uno pendiente:
 * genera expectativas que nadie se comprometió a cumplir.
 */
export function TermsPage(): JSX.Element {
  return (
    <LegalPlaceholder
      title="Términos y condiciones"
      notice={
        <>
          El texto contractual definitivo está en elaboración. Lo que sigue describe cómo funciona
          la tienda hoy, pero todavía no constituye un acuerdo formal.
        </>
      }
    >
      <LegalSection title="Qué es Mi Boleta">
        Una plataforma para comprar boletas y experiencias de los eventos publicados por las marcas
        aliadas. La marca organizadora es la responsable del evento; Mi Boleta gestiona la venta y
        la entrega de la boleta.
      </LegalSection>

      <LegalSection title="Tu cuenta">
        Necesitás una cuenta para comprar. Los datos que registres deben ser tuyos y estar
        correctos: la boleta se emite a nombre de quien figura en la cuenta, y el documento se usa
        para verificar la identidad en el ingreso al evento.
      </LegalSection>

      <LegalSection title="Compras y pagos">
        El precio mostrado incluye lo que se cobra al confirmar. Una compra queda firme cuando el
        pago se acredita; hasta entonces la reserva puede vencer y liberar el cupo.
      </LegalSection>

      <LegalSection title="Cambios y devoluciones">
        Las condiciones de cambio, devolución y reprogramación dependen de cada evento y de la marca
        organizadora. El detalle y los plazos quedan definidos en el documento formal.
      </LegalSection>
    </LegalPlaceholder>
  );
}
